import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const CardsContent = ({data, boName}) => {

    useEffect(() => {
        const summaryLabels = [
            `Total de ${boName}`,
            "Apreensões",
            "Flagrantes",
            "Veículos"
        ];

        const summaryValues = [
            data.boCards?.[0]?.total,
            data.boCards[0]?.apprehensions,
            data.boCards[0]?.flagrants,
            data.boCards[0]?.vehicles
        ];

        ReportUtils.createExportableTable(summaryLabels, summaryValues, "Cards");
    }, [data]);

    return (
        <>
            <div className="grid grid-cols-4 gap-2">
                <div className="text-center">
                    <div className="box" id="boxCount">
                        <h3>Total de {data.boName}</h3> <h2>{data.boCards[0]?.total ?? '0'}</h2>
                    </div>
                </div>

                <div className="text-center">
                    <div className="box" id="boxCount">
                        <h3>Apreensões</h3> <h2>{data.boCards[0]?.apprehensions ?? '0'}</h2>
                    </div>
                </div>

                <div className="text-center">
                    <div className="box" id="boxCount">
                        <h3>Flagrantes</h3> <h2>{data.boCards[0]?.flagrants ?? '0'}</h2>
                    </div>
                </div>

                <div className="text-center">
                    <div className="box" id="boxCount">
                        <h3>Veículos</h3> <h2>{data.boCards[0]?.vehicles ?? '0'}</h2>
                    </div>
                </div>
            </div>

            <div className="chart-divisor"></div>

        </>
    );
};

export default CardsContent;